  <nb-chat-message class="message" *ngIf="!customMessage" [type]="type" [message]="message" [reply]="reply"
    [sender]="sender" [date]="date" [dateFormat]="'dd/MM HH:mm'" [files]="files" [quote]="quote" [avatar]="Avatar">
  </nb-chat-message>

  <div *ngIf="customMessage">
    <!-- <nb-chat-message [message]="message" [sender]="sender" [date]="date"></nb-chat-message> -->
    <audio controls>
      <source [src]="files[0].url" type="audio/ogg">
    </audio>
  </div>